













import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
    components: {
    },
})
export default class StListItemWrap extends Vue {
    @Prop()type!: string;
    @Prop()noSideButtons!: boolean;

    get hasButtons(){
        return this.$slots.buttons;
    }

    get getClasses(){
        if(!this.type){
            if(!this.hasButtons){
                return 'xxl:min-w-500 xxl:max-w-500'
            }
            return 'min-w-500 max-w-500'
        }

        if(this.type == 'rate'){
            if(!this.hasButtons){
                return 'xxl:min-w-400 xxl:max-w-400'
            }
            return 'min-w-400 max-w-400'
        }
    }
}
